import { render, staticRenderFns } from "./plantcare.vue?vue&type=template&id=11d71744&scoped=true&"
import script from "./plantcare.vue?vue&type=script&lang=js&"
export * from "./plantcare.vue?vue&type=script&lang=js&"
import style0 from "./plantcare.vue?vue&type=style&index=0&id=11d71744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d71744",
  null
  
)

export default component.exports